import { PlanName, Product, WeldPlan } from "@/apollo/types";

import { WeldPlanBadge } from "./WeldPlanBadge";

type TargetPlan = { plan: WeldPlan; addOn: Product | null };

function UnavailableCronOptionBody(props: {
  currentPlanName: PlanName;
  targetPlan: TargetPlan;
}) {
  const { plan, addOn } = props.targetPlan;
  return (
    <>
      {addOn === null ? (
        <div>
          Available on the <WeldPlanBadge name={plan.name} /> plan.
        </div>
      ) : (
        <div>
          Available as an <strong>add-on</strong> to the{" "}
          <WeldPlanBadge name={plan.name} /> plan.
        </div>
      )}
    </>
  );
}

export function UnavailableCronOptionTooltipContent(props: {
  currentPlanName: PlanName;
  targetPlan?: TargetPlan | null;
}) {
  if (props.targetPlan == null) {
    return <>Unavailable on {props.currentPlanName} plan</>;
  }
  return (
    <div className="flex flex-col gap-4">
      <UnavailableCronOptionBody {...props} targetPlan={props.targetPlan} />
    </div>
  );
}
